








import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'i-restore',

})
export default class IRestore extends Vue {

  @Prop({type: [String], default: '#323232'}) protected color!: string

}

